import React from 'react';
import Navbar from '../components/navbar/navbar';
import HeroDetails from '../components/sections/hero-details';
import DetailsMain from '../components/sections/DetailsMain';
import Footer from '../components/sections/footer';

const PropertyDetails = () => {
    return ( 
        <>
            <Navbar />
            <HeroDetails />
            <DetailsMain />
            <Footer />
        </>
     );
}
export default PropertyDetails ;